import slugify from '~/techstyle-shared/react-components/src/utils/slugify';

/**
 * Returns the canonical resource bundle key for a swatch type label
 * (e.g. the small "Limited" / "Core" pill shown above a swatch on hover).
 *
 * The `swatch_type_` prefix namespaces these against unrelated `grid_dynamic`
 * keys (color/category slugs), and slugify normalizes casing and punctuation
 * so future swatch types resolve without code changes.
 *
 * @param {string} swatchType - The raw swatch type string (e.g. "Limited", "Core").
 * @returns {string} - The slugified RB key, or empty string for falsy input.
 */
export const getSwatchTypeRBKey = (swatchType) => {
  if (!swatchType) {
    return '';
  }
  return slugify(`swatch_type_${swatchType}`);
};
